<template>
  <div class="page">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list class="addressList" v-model="loading" :finished="finished" finished-text="已经到底线了" @load="loadmore" :immediate-check="false" :offset="0">
        <div class="addressList-item" v-for="(item,index) in list" :key="index" @click="chooseAddress(item)">
          <section style="display:flex; align-items:center">
            <div class="checkbox" :class="$route.query.address.id == item.id ? 'checkbox_active' : ''"></div>
            <div class="info">
              <p>{{item.consignee}}<span>{{item.phone}}</span><span class="default" v-if="item.is_default == 1 ">默认</span></p>
              <p class="info-det">{{item.province}}{{item.city}}{{item.district}}{{item.address}}</p>
            </div>
          </section>
          <section style="display:flex; align-items:center">
            <van-icon name="delete-o" @click.stop="del(item)" style="margin-right: 0.1rem;" />
            <van-icon name="edit" @click.stop="onEdit(item)" />
          </section>
        </div>
      </van-list>
    </van-pull-refresh>
    <p class="btn_add" @click="onAdd">新增地址</p>
  </div>
</template>
<script>
export default {
  created() {
    this.getData()
  },
  data() {
    return {
      chosenAddressId: '1',
      list: [],
      page: 1,
      loading: false,
      finished: false,
      refreshing: false,
      totalPages: 0
    }
  },
  methods: {
    getData() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      }
      let params = { p: this.page }
      this.common.request({
        url: 'UserAddress',
        methods: 'get',
        params: params,
        callback: res => {
          if (res.data.errcode == 0) {
            this.loading = false;
            this.list = res.data.data.data
            this.totalPages = res.data.data.totalPages
            if (this.totalPages <= this.page) {
              this.finished = true
            }
            if (this.list.length == 0) {
              this.finished = true
            }
          } else {
            this.finished = true
            this.loading = false
          }
        }
      })
    },
    loadmore() {
      setTimeout(() => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
        if (this.loading) {
          this.page = this.page + 1
          let params = { p: this.page }
          this.common.request({
            url: "UserAddress",
            methods: "post",
            params: params,
            callback: res => {
              if (res.data.errcode == 0) {
                this.loading = false;
                this.list = this.list.concat(res.data.data.data)
                this.totalPages = res.data.data.totalPages
                if (this.page >= this.totalPages) {
                  this.finished = true
                }
              } else {
                this.finished = true;
                this.loading = false;
              }
            }
          })

          if (this.page >= this.totalPages) {
            this.finished = true;
          }
        }
      }, 1000);
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.page = 1
      this.list = []
      this.loading = true;
      this.getData();
    },
    onAdd() {
      this.$router.push('/address')
    },
    onEdit(item, index) {
      this.$router.push('/address?id=' + item.id)
    },
    del(item) {
      let _this = this
      this.common.request({
        url: 'DelAddress',
        methods: 'post',
        params: { id: item.id },
        callback: res => {
          console.log(res.data.data)
          this.$toast.success('删除成功');
          setTimeout(function () {
            _this.getData()
          }, 1000)
          // if (res.data.errcode == 0) {
          //   this.$toast.success('删除成功');
          // } else {
          //   this.$toast.fail(res.data.errmsg);
          // }
        }
      })
    },
    chooseAddress(item) {
      console.log(123)
      this.$router.push({
        path: '/order',
        query: {
          id: this.$route.query.id,
          address: item
        }
      })
    }
  }
}
</script>
<style scoped>
.van-button--danger {
  background-color: #ddb253;
  background-image: url("../assets/btn_bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border: 1px solid #f0cd7b;
}
.van-address-list {
  padding: 0;
}
</style>
<style lang="less" scoped>
.page {
  padding-bottom: 0.5rem;
  max-width: 750px;
  margin: 0 auto;
}
.addressList {
  &-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.1rem;
    .checkbox {
      width: 0.13rem;
      height: 0.13rem;
      border: 1px solid #666666;
      border-radius: 50%;
    }
    .checkbox_active {
      border: 1px solid #c90827;
      position: relative;
      &::before {
        content: "";
        display: block;
        width: 0.06rem;
        height: 0.06rem;
        background: #c90827;
        border-radius: 50%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .info {
      margin: 0 0.1rem;
      flex: 1;
      p {
        font-size: 0.14rem;
        font-weight: 500;
        color: #333333;
        span {
          margin-left: 0.1rem;
        }
      }
      .default {
        background-color: #c90827;
        border-radius: 0.15rem;
        color: #fff;
        font-size: 0.12rem;
        padding: 0.01rem 0.1rem;
        display: inline-block;
      }
      &-det {
        font-size: 0.13rem !important;
        color: #666666 !important;
        margin-top: 0.05rem;
      }
    }
  }
}
.btn_add {
  position: fixed;
  max-width: 750px;
  left: 50%;
  bottom: 0.1rem;
  transform: translateX(-50%);
  width: 90%;
  height: 0.4rem;
  background: linear-gradient(270deg, #ddb253, #f0cd7b);
  background-image: url("../assets/btn_bg.png");
  background-size: 100% 100%;
  border-radius: 0.2rem;
  text-align: center;
  line-height: 0.4rem;
  color: #fff;
  font-size: 0.15rem;
}
</style>